module.exports = __webpack_public_path__ + "img/diminished fifth.53377ee6.jpg";